// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.AddDiscountItemRequest */
/* istanbul ignore next */
@GandalfModel
export class AddDiscountItemRequest extends GandalfModelBase {

	@GandalfLabel('Discount Amount')
	@GandalfValidator({ notNull: { message: 'Discount Amount is required' } })
	@GandalfValidator({ moneyConstraints: { positiveAllowed: true, zeroAllowed: true, negativeAllowed: false, message: 'Discount Amount cannot be negative' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	discountAmount!: number;

	@GandalfLabel('Discount Percent')
	@GandalfProperty({ designType: Number })
	discountPercent!: number | null;

	@GandalfLabel('Invoice Item')
	@GandalfValidator({ notNull: { message: 'Invoice Item is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceItemId!: number;

}
